/* eslint no-console:0 */
import { SCHEMA_SVC_API_MAP } from 'config/values';
import 'regenerator-runtime';

const waitForApiKeys = () => {
  return new Promise(resolve => {
    if (window.apiKeysReady) {
      resolve();
    } else {
      // Poll every 100ms until keys are ready (max 5 seconds)
      let attempts = 0;
      const checkInterval = setInterval(() => {
        attempts++;
        if (window.apiKeysReady || attempts > 50) {
          clearInterval(checkInterval);
          resolve();
        }
      }, 100);
    }
  });
};

const fetchFormSchema = async type => {
  // Wait for API keys to be ready before making request
  await waitForApiKeys();

  const API = SCHEMA_SVC_API_MAP[type];
  const fetchOptions = {
    method: 'GET',
    headers: { 'x-api-key': API.apiKey }
  };

  try {
    const response = await fetch(API.uri, fetchOptions);

    return await response.json();
  } catch (e) {
    console.error(e);
    return Promise.reject();
  }
};

export default fetchFormSchema;
